import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.account = 15705;
    this.jspass = 'ca8h5wkaotnr98zc4y7s';
    this.navisBaseUrl =
      'https://twi.revinate.com/JavascriptPhoneNumber/js.aspx?account={{account}}&jspass={{jspass}}&dflt={{dflt}}';

    this.dom = {
      phone: this.el.querySelector('.section-snapshot__phone')
    };

    if (
      this.dom.phone &&
      this.dom.phone.dataset.useNavis?.toLowerCase() === 'true'
    ) {
      this.updateElementWithNavisNumber();
    }
  }

  updateElementWithNavisNumber() {
    const defaultPhone = this.dom.phone.dataset.defaultNavisNumber;

    if (!defaultPhone) return;

    this.loadScript(defaultPhone, error => {
      if (error) {
        this.dom.phone.innerHTML = this.dom.phone.dataset.navisPrepend
          ? `${this.dom.phone.dataset.navisPrepend} ${defaultPhone}`
          : defaultPhone;

        return;
      }

      window.ProcessNavisNCKeyword();
      this.updateElement();
    });
  }

  loadScript(defaultPhone, callback) {
    const url = this.getNavisUrlFor(defaultPhone);
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
      //IE
      script.onreadystatechange = () => {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
      script.onerror = () => callback(new Error('failed to load Navis script'));
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  getNavisUrlFor(defaultPhone) {
    let url = this.navisBaseUrl.replace(/{{account}}/g, this.account);
    url = url.replace(/{{jspass}}/g, this.jspass);
    url = url.replace(/{{dflt}}/g, defaultPhone);

    return url;
  }

  updateElement() {
    // modified logic from #5: https://twi.revinate.com/wisdom_external/Dynamic_telephone_number_coding.pdf
    const navisTfnRaw = window.NavisConvertTagToPhoneNumberBasic(
      window.ReadNavisTagCookie()
    );

    const navisTfnDisp = window.FormatPhone(navisTfnRaw, '###-###-####');
    const navisTfnHref = window.FormatPhone(navisTfnRaw, '###-###-####');

    this.dom.phone.href = `tel:+1-${navisTfnHref}`;
    this.dom.phone.innerHTML = this.dom.phone.dataset.navisPrepend
      ? `${this.dom.phone.dataset.navisPrepend} ${navisTfnDisp}`
      : navisTfnDisp;
    this.dom.phone.title = navisTfnDisp;
  }
}

export default Module;
